module.exports = __webpack_public_path__ + "img/Lanternes_volantes_de_mariage.e2ba5b1.jpg";